import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-selection-dialog',
  templateUrl: './user-selection-dialog.component.html',
  styleUrls: ['./user-selection-dialog.component.scss'],
  standalone: false,
})
export class UserSelectionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UserSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  // Close the dialog and return the selected user
  selectUser(user: any): void {
    this.dialogRef.close(user);
  }

  // Close the dialog without selecting a user
  cancel(): void {
    this.dialogRef.close(null);
  }
}